import { h } from '@atomify/jsx';
import { ButtonRound } from '@atoms/button-round/button-round';
import { closeModal, dismissCloseModal } from '@store/modals';
import { useTranslate } from '@utilities/hooks';

interface ModalWrapperInterface {
    id: string;
    active: boolean;
    title?: string | Text;
    noPadding?: boolean;
    hasConfirmationPopup?: boolean;
    children?: any;
    classes?: string;
    onClose?: () => void;
}

export const ModalWrapper = ({
    id,
    active,
    title = '',
    noPadding,
    children,
    classes,
    hasConfirmationPopup,
    onClose,
}: ModalWrapperInterface) => (
    <bpd-modal
        id={id}
        active={active}
        has-confirmation-popup={hasConfirmationPopup}
        onModalClose={onClose}>
        <div class={`c-modal-wrapper ${classes || ''}`.trim()}>
            <ButtonRound
                ariaLabel="Modal button"
                svg="icons-close"
                variant="grey-5"
                size="small"
                classes="modal-wrapper__button"
                hook="modal-trigger"
                attributes={{
                    ['aria-controls']: id,
                    ['data-modal-action']: hasConfirmationPopup ? 'closeConfirmation' : 'close',
                }}
            />
            {hasConfirmationPopup && (
                <modal-close-confirmation-popup
                    modalId={id}
                    title={useTranslate('ModalCloseConfirmationPopupTitle')}
                    description={useTranslate('ModalCloseConfirmationPopupDescription')}
                    confirmButtonText={useTranslate('ModalCloseConfirmationPopupConfirmLinkText')}
                    closeButtonText={useTranslate('ModalCloseConfirmationPopupLinkText')}
                    onConfirm={() => closeModal(id)}
                    onDismiss={() => dismissCloseModal(id)}
                />
            )}

            <div
                class={`modal-wrapper__content${noPadding ? ' no--padding' : ''}`}
                js-hook-modal-wrapper-content>
                {!!title && <h2 class="u-title-underlined">{title}</h2>}
                {children}
            </div>
        </div>
    </bpd-modal>
);
